const TRUSTED_SNIPER_HOSTS = ['sniper-hom.manole.com.br', 'sniper-prod.manole.com.br']
const MEDIA_PATH_PREFIX = '/api/v1/livros/midia/'
const INFORMED_CMS_CONSUMER = 'informed-cms'

const getQueryParam = (search, name) => {
  const pairs = (search || '').replace(/^\?/, '').split('&')
  const prefix = name + '='
  const match = pairs.find(pair => pair.indexOf(prefix) === 0)

  return match ? decodeURIComponent(match.slice(prefix.length)) : null
}

const isTrustedSniperMediaUrl = value => {
  try {
    const url = document.createElement('a')
    url.href = value
    const consumer = getQueryParam(url.search, 'consumer')
    return (
      url.protocol === 'https:' &&
      TRUSTED_SNIPER_HOSTS.includes(url.hostname) &&
      url.pathname.startsWith(MEDIA_PATH_PREFIX) &&
      (consumer === null || consumer === INFORMED_CMS_CONSUMER)
    )
  } catch (e) {
    return false
  }
}

export const prepareImagesForCms = html => {
  if (!html) return html

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    doc.querySelectorAll('img').forEach(img => {
      const src = (img.getAttribute('src') || '').trim()
      if (!isTrustedSniperMediaUrl(src)) return

      const marker = doc.createElement('span')
      marker.setAttribute('class', 'linkJPG')
      marker.textContent = src
      img.parentNode.replaceChild(marker, img)
    })

    return doc.body.innerHTML
  } catch (e) {
    return html
  }
}

export { isTrustedSniperMediaUrl }



// WEBPACK FOOTER //
// ./src/utils/cmsHtmlImages.js